function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M249,158.5a8.5,8.5,0,0,0,0-17h-9.5v-64H249a8.5,8.5,0,0,0,0-17h-9.5V51a8.5,8.5,0,0,0-17,0v9.5h-64V51a8.5,8.5,0,0,0-17,0v9.5h-64V51a8.5,8.5,0,0,0-17,0v9.5H51a8.5,8.5,0,0,0,0,17h9.5v64H51a8.5,8.5,0,0,0,0,17h9.5v64H51a8.5,8.5,0,0,0,0,17h9.5V249a8.5,8.5,0,0,0,17,0v-9.5h64V249a8.5,8.5,0,0,0,17,0v-9.5h64V249a8.5,8.5,0,0,0,17,0v-9.5H249a8.5,8.5,0,0,0,0-17h-9.5v-64Zm-26.5-81v64h-64v-64Zm-145,0h64v64h-64Zm0,145v-64h64v64Zm145,0h-64v-64h64Z"
});

var SvgGrid = function SvgGrid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 300 300",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGrid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/grid.e9d87a44.svg";
export { ForwardRef as ReactComponent };